export enum GeotrackContainerTypes {
  Geotrack = 'Geotrack',
  GeotrackNormalization = 'GeotrackNormalization',
  GeotrackModalsFacade = 'GeotrackModalsFacade',
}
